/* ═══════════════════════════════════════════════════════════
   LOST AND FOUND — END OF SEASON SALE (EOSS)
   Countdown • live cart bundle-progress • checkout routing.
   Config comes from window.LF.eoss (emitted in layout/theme.liquid).
   All guarded — no-ops cleanly if the campaign is off/expired.
   ═══════════════════════════════════════════════════════════ */
(function () {
  var E = (window.LF && window.LF.eoss) || null;
  if (!E || !E.enabled) return;

  var need = parseInt(E.qty, 10) || 2;
  var price = parseInt(E.price, 10) || 0;

  var idSet = {};
  (E.ids || []).forEach(function (id) { idSet[id] = true; });

  function pad(n) { return n < 10 ? '0' + n : '' + n; }
  function fmtRs(rupees) { return '₹' + Math.round(rupees).toLocaleString('en-IN'); }

  /* Count qualifying oversized tees in a /cart.js payload.
     Line items expose product_id; we match against the collection's
     product ids emitted server-side. Returns null if cart unusable. */
  function countQualifying(cart) {
    if (!cart || !cart.items || !cart.items.length) return cart && cart.items ? 0 : null;
    var q = 0;
    cart.items.forEach(function (it) { if (idSet[it.product_id]) q += it.quantity; });
    return q;
  }

  /* ───────── COUNTDOWN (rolling 24h) + real expiry ───────── */
  var expiryTs = (E.endTs && E.endTs > 0) ? E.endTs : 0; /* real campaign end → auto-hide everything */
  var cdEls = document.querySelectorAll('[data-eoss-cd]');
  var timerEls = document.querySelectorAll('[data-eoss-timer]');
  var expired = false;
  var DAY = 86400000;
  var IST = 5.5 * 3600000; /* renew the visible timer at IST midnight */

  function setUnit(root, unit, val) {
    var el = root.querySelector('[data-unit="' + unit + '"]');
    if (el) el.textContent = val;
  }
  function hideCampaign() {
    document.querySelectorAll('[data-eoss]').forEach(function (el) { el.style.display = 'none'; });
  }
  /* ms left in the current 24h cycle — auto-renews every 24h, identical for every visitor */
  function cycleRemaining() { return DAY - ((Date.now() + IST) % DAY); }
  function tickCountdown() {
    if (expiryTs && Date.now() >= expiryTs) { if (!expired) { expired = true; hideCampaign(); } return; }
    var s = Math.floor(cycleRemaining() / 1000);
    var hrs = Math.floor(s / 3600);
    var mins = Math.floor((s % 3600) / 60);
    var secs = s % 60;
    cdEls.forEach(function (cd) {
      setUnit(cd, 'hours', pad(hrs));
      setUnit(cd, 'minutes', pad(mins));
      setUnit(cd, 'seconds', pad(secs));
    });
    var compact = pad(hrs) + 'h ' + pad(mins) + 'm';
    timerEls.forEach(function (t) { var b = t.querySelector('b'); if (b) b.textContent = compact; });
  }
  tickCountdown();
  setInterval(tickCountdown, 1000);

  /* ───────── CART BUNDLE PROGRESS ───────── */
  var lastQty = 0;

  function renderBars(qty) {
    var unlocked = qty >= need;
    document.querySelectorAll('[data-eoss-cartbar]').forEach(function (bar) {
      if (qty <= 0) { bar.style.display = 'none'; return; }
      bar.style.display = '';
      bar.classList.toggle('is-unlocked', unlocked);

      var fill = bar.querySelector('[data-eoss-cartbar-fill]');
      if (fill) fill.style.width = Math.min(100, Math.round((qty / need) * 100)) + '%';

      var textEl = bar.querySelector('[data-eoss-cartbar-text]');
      if (textEl) {
        if (unlocked) {
          var pairs = Math.floor(qty / need);
          textEl.innerHTML = (pairs > 1 ? pairs + ' bundles unlocked' : 'Bundle unlocked') +
            ' — <strong>' + need + ' Oversized Tees for ' + fmtRs(price) + '</strong>';
        } else {
          var left = need - qty;
          textEl.innerHTML = 'Add <strong>' + left + ' more oversized tee' + (left === 1 ? '' : 's') +
            '</strong> to get ' + need + ' for <strong>' + fmtRs(price) + '</strong>';
        }
      }
      var cta = bar.querySelector('[data-eoss-cartbar-cta]');
      if (cta) cta.style.display = unlocked ? 'none' : '';
    });
    routeCheckout(qty >= need);
  }

  /* When unlocked, send checkout through the discount permalink so the
     code is applied automatically. Harmless if the code doesn't exist
     (Shopify just redirects to checkout). Skipped if no code configured
     (e.g. a Shopify Function is doing the discount instead). */
  function permalink() { return '/discount/' + encodeURIComponent(E.code) + '?redirect=/checkout'; }
  function routeCheckout(unlocked) {
    if (!E.code) return;
    var pageBtn = document.querySelector('.cart-page__checkout-btn');
    if (pageBtn) pageBtn.setAttribute('href', unlocked ? permalink() : '/checkout');
  }
  /* Drawer checkout is a form submit — intercept it when unlocked. */
  document.addEventListener('click', function (e) {
    if (!E.code) return;
    var btn = e.target.closest && e.target.closest('#cartDrawerCheckout');
    if (btn && lastQty >= need) { e.preventDefault(); window.location.href = permalink(); }
  });

  function update(cart) {
    var q = countQualifying(cart);
    if (q === null) q = (typeof E.qtyInCart === 'number' ? E.qtyInCart : 0);
    lastQty = q;
    renderBars(q);
  }
  function fetchAndUpdate() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(update).catch(function () {});
  }

  /* Optimistic cart:updated events carry items:[] — refetch for an
     accurate qualifying-count; real events carry full items. */
  document.addEventListener('cart:updated', function (e) {
    if (e.detail && e.detail.items && e.detail.items.length) update(e.detail);
    else fetchAndUpdate();
  });
  document.addEventListener('cart:open', fetchAndUpdate);

  if (typeof E.qtyInCart === 'number') { lastQty = E.qtyInCart; renderBars(E.qtyInCart); }
  fetchAndUpdate();
})();
